import React from 'react'
import { Button, Divider, TextField, InputAdornment } from '@mui/material'
import { Tune, Search } from '@mui/icons-material'
import DateSelection from '../../components/date-selection/DateSelection'
import { SearchResultChip } from '../../components/SearchResult/SearchResult'
import FilterDrawer from '../../components/filter/FilterDrawer'
import EventMainCard from '../../components/Cards/EventMainCard'
import EventListingCardsSkeleton from '../../components/skeleton/EventListingCards'
import EventDescriptionCarousel from '../../components/EventMetaDescription/EventDescriptionCarousel'
import useEventFilter from '../../hooks/event-hooks/event-filter/useEventFilter'
import { H3, H4 } from '../../themes/typography'
import "../../styles/event/EventDiscovery.css"

function EventDiscovery() {

    const {
        eventFilterConfig,
        filterState,
        setFilterState,
        openFilter,
        handleOpenFilter,
        handleCloseFilter,
        clearAllFilter,
        applyFilter,
        filterEvents,
        filterResultChips,
        removeSelectedFilterChip,
        isEventLoading,
        setDateRange,
        getEventDate,
        error,
        shouldDisableApplyFilterBtn,
        loadNextMonthEvents,
        eventsMonthInfo
    } = useEventFilter();

    return (
        <React.Fragment>
            <div id="event-discovery-main-page" className='page-view'>

                <div className='event-discovery-page-wrapper page-wrapper'>

                    <EventDescriptionCarousel />

                    <div className='discover-your-scene-main-container'>

                        <div className='discover-your-scene-wrapper'>

                            <div className='discover-your-scene-heading'>
                                <H3 color="var(--secondary-color)">Discover Your Scene</H3>
                            </div>

                            <div className='discover-your-events-filter-container'>

                                <div className='discover-your-events-date-filter'>

                                    <div className='discover-your-events-searchbar'>
                                        <TextField
                                            placeholder='Search for events, interests or activities.'
                                            fullWidth
                                            slotProps={{ input: { startAdornment: <SearchIcon /> } }}
                                            sx={searchInputStyle}
                                        />
                                    </div>


                                    <DateSelection
                                        onDateChange={(start, end) => setDateRange([start, end])}
                                        onMonthChange={(month) => loadNextMonthEvents(month)}
                                    />
                                </div>

                                <div className='discover-events-filter-and-chips'>
                                    <div className='discover-your-events-filter-button'>
                                        <Button
                                            variant="toggleActive"
                                            endIcon={<Tune />}
                                            onClick={handleOpenFilter}
                                        >
                                            Filter
                                        </Button>
                                    </div>

                                    <div className='discover-your-events-verticle-line'></div>

                                    <div className='discover-your-events-chips'>
                                        {filterResultChips?.map(chip => (
                                            <SearchResultChip
                                                key={chip.key}
                                                chipName={chip.name}
                                                onDelete={() => removeSelectedFilterChip(chip)}
                                            />
                                        ))}
                                    </div>
                                </div>


                            </div>
                            <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

                        </div>

                    </div>

                    <div className='discover-your-events-cards-container'>

                        {eventsMonthInfo.notFoundMonthName && eventsMonthInfo.foundMonthName && (
                            <div className='no-events-found-container'>
                                <H4>
                                    No event scheduled for {''}
                                    <span>
                                        {eventsMonthInfo.notFoundMonthName}
                                    </span>
                                </H4>
                                <H4>
                                    Showing next <span>{eventsMonthInfo.foundMonthName}</span> month events
                                </H4>
                            </div>
                        )}

                        <div className='discover-your-events-cards-listing'>

                            {isEventLoading && <EventListingCardsSkeleton />}

                            {!isEventLoading && filterEvents?.length > 0 && filterEvents?.map((event, index) => (
                                <EventMainCard
                                    key={index}
                                    slug={event?.slug}
                                    name={event?.excerpt}
                                    location={event?.address}
                                    startingTime={event?.start_time}
                                    startingDate={getEventDate(event?.used_schedule_id)}
                                    price={event?.min_ticket_price}
                                    organizerAvatar={event?.user_avatar}
                                    format={event?.formats}
                                />
                            ))}

                            {!isEventLoading && filterEvents?.length === 0 && error === null && (
                                <H3 color="var(--secondary-color)">
                                    No events found
                                </H3>
                            )}

                            {error && (
                                <H3 color="var(--secondary-color)">
                                    {error}
                                </H3>
                            )}

                        </div>

                    </div>
                </div>

            </div>
            <FilterDrawer
                disabled={isEventLoading || shouldDisableApplyFilterBtn}
                loading={isEventLoading}
                eventFilterConfig={eventFilterConfig}
                filterState={filterState}
                setFilterState={setFilterState}
                openFilter={openFilter}
                handleCloseFilter={handleCloseFilter}
                clearAllFilter={clearAllFilter}
                applyFilter={applyFilter}
            />
        </React.Fragment>
    )
}

export default EventDiscovery

function SearchIcon() {
    return (
        <InputAdornment position="start">
            <Search sx={{ color: 'var(--quaternary-color)' }} />
        </InputAdornment>
    );
}

const searchInputStyle = {
    '& .MuiOutlinedInput-input': {
        padding: '14px',
        paddingLeft: '0'
    }
}